import { PalletTemplates } from './PalletTemplates';

export default PalletTemplates;
